import axios from "axios";
import {
  hasSessionExpired,
  getSessionFromStorage,
  authHeaders,
  createSession,
} from "./session";
import { SESSION_STORAGE_KEY, PARAMETERS_STORAGE_KEY, domain, headers } from "./config";

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log("error is ", error);
  if(error.response.status === 401){
    localStorage.removeItem(SESSION_STORAGE_KEY);
    localStorage.removeItem(PARAMETERS_STORAGE_KEY);
    window.location.href= "/login";
  }
  return Promise.reject(error);
});

const refreshTokenFetch = async (credential) => {
  const fetchAuthRefreshData = async () => {
    const response = await fetch(domain + "auth-api/refresh-token", {
      method: "POST",
      headers: headers,
      body: JSON.stringify(credential),
    });

    if (!response.ok) {
      throw new Error("Could not able to do the authentication Refresh Token!");
    }
    const data = await response.json();
    return data;
  };
  try {
    const authData = await fetchAuthRefreshData();
    const session = createSession(authData.content);
    localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(session));
    return authData;
  } catch (error) {
    console.error("Error on Refresh API Call!");
    localStorage.removeItem(SESSION_STORAGE_KEY);
    localStorage.removeItem(PARAMETERS_STORAGE_KEY);
    window.location.href= "/login";
  }
};

const generateHeadersRefresh = () => {
    const session = getSessionFromStorage();
    const data = {
      value: session.refresh_token,
    }
   const newSession = refreshTokenFetch(data);

   return newSession;

}

const axiosGetHandler = async(url,headerParam) => {
  return await axios.get(url,{headers: authHeaders(headerParam)}).then((response) => {
    return response;
  })
  .catch((error) => {
    return Promise.reject(error);
  });
}

export const axiosGetRequest = async (url,  headers = "") => {
  if(hasSessionExpired()){
   let getHeaders = generateHeadersRefresh();
   return getHeaders.then(async(resp)=>{
    return await axiosGetHandler(url,resp.content);
   })
  }
  else{
   return await axiosGetHandler(url,getSessionFromStorage());
  }
};

const axiosPostHandler = async(url,data,headerParam) => {
  return await axios.post(url,data,{headers: authHeaders(headerParam)}).then((response) => {
    return response;
  })
  .catch((error) => {
    return Promise.reject(error);
  });
}

export const axiosPostRequest = async (url, data, headers = "") => {
  if(hasSessionExpired()){
    let getHeaders = generateHeadersRefresh();
    return getHeaders.then(async(resp)=>{
     return await axiosPostHandler(url,data,resp.content);
    })
   }
   else{
    return await axiosPostHandler(url,data,getSessionFromStorage());
   }
};

const axiosPutHandler = async(url,data,headerParam) => {
  return await axios.put(url,data,{headers: authHeaders(headerParam)}).then((response) => {
    return response;
  })
  .catch((error) => {
    return Promise.reject(error);
  });
}

export const axiosPutRequest = async (url, data, headers = "") => {
  if(hasSessionExpired()){
    let getHeaders = generateHeadersRefresh();
    return getHeaders.then(async(resp)=>{
     return await axiosPutHandler(url,data,resp.content);
    })
   }
   else{
    return await axiosPutHandler(url,data,getSessionFromStorage());
   }
};

const axiosDeleteHandler = async(url,headerParam) => {
  return await axios.delete(url,{headers: authHeaders(headerParam)}).then((response) => {
    return response;
  })
  .catch((error) => {
    return Promise.reject(error);
  });
}

export const axiosDeleteRequest = async (url, headers = "") => {
  if(hasSessionExpired()){
    let getHeaders = generateHeadersRefresh();
    return getHeaders.then(async(resp)=>{
     return await axiosDeleteHandler(url,resp.content);
    })
   }
   else{
    return await axiosDeleteHandler(url,getSessionFromStorage());
   }
};


// Remove 
export const axiosRequest = async (url, method = "", data = "", headers = "") => {
  // checkSession();
  if(hasSessionExpired()){
    const session = getSessionFromStorage();
    const data = {
      value: session.refresh_token,
    }
    refreshTokenFetch(data);
  }
  if (method === "" || method.toUpperCase() === "GET") {
    const { data } = await axios(url,{headers:
      headers !== ""
        ? headers:  {
        "Content-Type": "application/json",
    }});
    return await data;
  } else if (method.toUpperCase() === "POST") {
    return axios({
      method: method,
      headers:  {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Referrer-Policy": "no-referrer",
      },
      url: url,
      data: data,
      
    });
  }
};

const axiosPostHandlerForInfiniteScroll = async (url, data, headerParam) => {
  return await axios
    .post(url, data, { headers: authHeaders(headerParam) })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const axiosPostRequestForInfiniteScroll = async (url, data) => {
  if (hasSessionExpired()) {
    let getHeaders = generateHeadersRefresh();
    return getHeaders.then(async (resp) => {
      return await axiosPostHandlerForInfiniteScroll(url, data, resp.content);
    });
  } else {
    return await axiosPostHandlerForInfiniteScroll(
      url,
      data,
      getSessionFromStorage()
    );
  }
};

const axiosGetHandlerForInfiniteScroll = async (url, data, headerParam) => {
  return await axios
    .get(url, { headers: authHeaders(headerParam) })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const axiosGetRequestForInfiniteScroll = async (
  url,
  data,
  headers = ""
) => {
  if (hasSessionExpired()) {
    let getHeaders = generateHeadersRefresh();
    return getHeaders.then(async (resp) => {
      return await axiosGetHandlerForInfiniteScroll(url, data, resp.content);
    });
  } else {
    return await axiosGetHandlerForInfiniteScroll(
      url,
      data,
      getSessionFromStorage()
    );
  }
};